export default __webpack_public_path__ + "static/media/logo-illustration.6ff92510.svg";